import { Office } from "./s10Corporation.interface";


interface MyData<T> {
  [key: string]: T;
}

export enum UserRegistrationType {
  PorCorporacion = 0,
  Bolsa = 1,
  PorProyecto = 2
}
export const getUserRegistrationTypeName = (type: UserRegistrationType): string => {
  const names: Record<UserRegistrationType, string> = {
    [UserRegistrationType.PorCorporacion]: 'Por Corporación',
    [UserRegistrationType.Bolsa]: 'Bolsa',
    [UserRegistrationType.PorProyecto]: 'Por Proyecto'
  };
  
  return names[type] || 'Desconocido';
};
export interface License {
  Id: number;
  SecurityModuleId: number;
  ModuleName: string;
  UsersNumber: number;
  UsersActive: number;
  UserRegistration: UserRegistrationType;

//   "SecurityModuleId": 1,   //ID DEL MODULO
//   "ModuleName": "Portal del Colaborador", //NOMBRE DEL MODULO
//   "UsersNumber": 1,  // SI EL DATO ES MAYOR A 1 ES QUE TIENE LICENCIA
//   "UsersActive": 5,  // NUMERO DE USUARIO REGISTRADOS Y CON CUENTA ACTIVA PARA EL MODULO
//   "UserRegistration": 0  //EL TIPO DE LICENCIAMIENTO EL CUAL PUEDE SER:

//             0:Por Corporación: Solo se vende 1 licencia a la corporación  y esta puede crear cualquier numero de usuarios
//             1:Bolsa: Cada licencia (login) es independiente.
//             2:Por proyecto:  Ventas le asigna una licencia a cada proyecto que indiquen y solo podrán conectar a ellos. El número de usuarios que pueden crear es indefinido.
}

export interface S10Response<T extends MyData<any>> {
  data: T;
  count: number;
  part: number;
  outputValue?: string;
}

export interface S10GenericResponse<T extends MyData<any>> {
  Type: number
  Message: string
  Value: T
}
export interface AuthResponse {
  Type: number
  Message: string
  Value: AuthData
  Validates?: any
}
  
  export interface AuthData {
    Companies: Company[]
    ModuleId: number
    UserName: string
    FullName: string
    FirstName: string
    LastName: string
    MiddleName: string
    UserId: number
    IsInvitationUser: boolean
    CorporationURL: any
    Roles?: Company['Roles']
  }
  
  export interface Company {
    Id: number
    CorporationId: number
    Name: string
    Logo: any
    SchemaName: string
    RUC: string
    Ruc: string
    DatabaseNameERP: string
    Code: string
    IsActive: boolean
    Token: string
    CorporationModuleId: number
    HasCorporationURL: boolean
    Projects: any[]
    Roles: Roles
  }
  
  export interface Roles {
    Id: number
    Name: string
    IsAdministrator: boolean
    Access: Access[]
  }
  
  export interface Access {
    Id: number;
    SecurityRoleId: number;
    SecurityAccessId: number;
    IsStartPage: boolean;
    Name: string;
    ItemPath: string;
    Icon: string;
    Visible: boolean;
    ParentId?: number;
    Order: number;
    Level: number;
    children?: Access[],
    urlPath: string
  }
  

  export interface ChangePasswordRequest {
    CurrentPassword: string;
    NewPassword: string;
    ConfirmNewPassword: string;
  }

export interface UserData {
  Activo: boolean
  Aniversario: string
  ApellidoMaterno: string
  ApellidoPaterno: string
  AvisarEmergenciaNombre: string
  AvisarEmergenciaTelefono: string
  Carrera: any
  CodCarrera: any
  CodEstadoCivil: string
  CodIdentificador: string
  CodInstitucionEducativa: any
  CodNacionalidad: any
  CodProyecto: any
  CodSituacionEducativa: string
  CodTipoDocumento: string
  CodUbigeoDireccion: string
  Colegiado: boolean
  DNI: string
  DescripcionEmpresa: string
  Direccion: string
  EMail: string
  EMailPersonal: any
  EstadoCivil: string
  InstitucionEducativa: any
  LugarDireccion: string
  LugarNacimiento: any
  Nacionalidad: any
  NombreConyugue: any
  Nombres: string
  NroEsquemaPlanilla: any
  NroFS: string
  NumeroColegiatura: string
  NumeroHijos: any
  NumeroLicenciaConducir: string
  Proyecto: any
  RUCEmpresa: string
  Regimen: any
  Sexo: "M" | "F"
  SituacionEducativa: string
  TelefonoFijo: string
  TelefonoMovil: string
  Tipo: number
  TipoDocumento: string
}

export interface UserDataToUpdate {
  ApellidoMaterno: string
  ApellidoPaterno: string
  Nombres: string
  Sexo: "M" | "F"
  Direccion: string
  TelefonoMovil: string
}

export interface UserRightHolders {
  ApellidoMaterno: string
  ApellidoPaterno: string
  CodIdentificador: string
  CodIdentificadorDH: string
  DNI: string
  Descripcion: string
  FechaNacimiento: string
  Nombres: string
  NroIdentificadorDH: string
}


export interface UserUpdateRightHolder {
  DNI: string
  ApellidoPaterno: string
  ApellidoMaterno: string
  Nombres: string
  FechaNacimiento: string //En formato dd/mm/yyyy
  Operacion: 0 | 1 | 2 // 1:Modifica  2:Elimina
}

export interface UserUpdateTraining {
  // DNI: string;
  CodTipoCapacitacion: '01' | '02' | '03' | '04';
  CodInstitucionEducativa: string;
  Descripcion: string;

  FechaInicio: string;
  FechaFin: string;
  Operacion: 0 | 1 | 2; // 1:Modifica  2:Elimina
  guid: string;
}
export interface Training {
  CodIdentificador: string;
  CodInstitucionEducativa: string;
  CodTipoCapacitacion: string;
  Descripcion: string;
  FechaFin: string;
  FechaInicio: string;
  InstitucionEducativa: string;
  NroIdentificadorCapacitacion: string;
  TipoCapacitacion: string;
}


export interface UserHealthPlan {
  CodIdentificador: string;
  Descripcion: string;
  RegimenSalud: string;
}

export interface UserVacationsResume {
  Activo: string;
  CodIdentificador: string;
  DNI: string;
  DiasAsignado: number;
  DiasAtrasados: number;
  DiasGanados: number;
  DiasGanadosHistorico: number;
  DiasGanadosVigente: number;
  DiasLiquidados: number;
  DiasPorUtilizar: number;
  DiasPendientes: number;
  DiasProgramado: number;
  DiasTruncos: number;
  DiasUtilizado: number;
  EsquemaPlanilla: string;
  FechaCese: null | string;
  FechaIngreso: string;
  Nombre: string;
  ProyectoDestino: string;
  Saldo: number;
  SaldoProgramado: number;
}

export interface UserTrainingUpdate {
  CodTipoCapacitacion: string;
  CodInstitucionEducativa: string;
  Descripcion: string;
  FechaInicio: string;
  FechaFin: string;
  Operacion: 0 | 1 | 2;  
}   

export interface College {
  Abreviatura: string | null;
  CodTablaTablas: string;
  Descripcion: string;
}

export interface ApprovalGroupsCompanies {
  CodIdentificador: string;
  Descripcion: string;
  EMail: string;
  RUC: string;
}

export interface UserAssignedCompanies {
  CodIdentificador: string;
  DescripcionEmpresa: string;
  RUCEmpresa: string;
}
export interface ApprovalGroups {
  [key: string]: any;
  Id: number;
  Name: string;
  IsActive: string;
  ApproversNumber: number;
  NotificationGroupId: number;
  NotificationGroupName: string;
  OfficeId: number;
  OfficeName: string;
}

export interface NotificationGroups {
  [key: string]: any;
  Id: number;
  Type: number;
  Name: string;
  TypeName: string;
  
}

export interface NotificationGroup {
  Id: number;
  Name: string;
}

export interface SaveNotificationGroup {
  Name: string;
  Type: number;
  CompanyCode: string;
}

export interface SaveApprovalGroup {
  Name: string;
  ApproversNumber: number;
  NotificationGroupId: number;
  CompanyCode: string;
}

export interface ModifyNotificationGroup {
  Id: number;
  Name: string;
  Type: number;
}

export interface ModifyApprovalGroup {
  Id: number;
  Name: string;
  ApproversNumber: number;
  NotificationGroupId: number;
}
export interface ApprovalResponsablesPartial {
  ApprovalGroupResponsableCode: string;
  Id: number;
  Required: boolean;
  RoleId: number;
  RoleName: string;
  SecurityUserId: number;
}

export interface ApprovalResponsables {
  [key: string]: any;
  responsableId: number;
  Activo: boolean;
  Aniversario: string;
  CodIdentificador: string
  CodProyecto: string | null;
  DNI: string;
  Descripcion: string;
  DescripcionEmpresa: string | null;
  EMail: string;
  NombreEsquemaPlanilla: string | null;
  NombreProyecto: string | null;
  NroFS: string | null;
  RUCEmpresa: string | null;
  Tipo: number;
  TipoDocumento: string;
  RoleId?: number;
  RoleName?: string;
}
export interface ApprovalEmployees {
  Activo: boolean;
  Aniversario: string;
  CodIdentificador: string;
  CodProyecto: string;
  DNI: string;
  Descripcion: string;
  DescripcionEmpresa: string;
  EMail: string;
  NombreEsquemaPlanilla: string;
  NombreProyecto: string;
  NroFS: string;
  RUCEmpresa: string;
  Tipo: number;
  TipoDocumento: string;
  Id: number;
  parentData?: Office;
  Cargo?: string;
}

export interface CompanyEmployees {
  RUCEmpresa: string | null;
  Activo: boolean;
  Aniversario: string;
  CodIdentificador: string
  CodProyecto: string | null;
  DNI: string;
  Descripcion: string;
  DescripcionEmpresa: string | null;
  EMail: string;
  NombreEsquemaPlanilla: string | null;
  NombreProyecto: string | null;
  Tipo: number;
  TipoDocumento: string;
  NroEsquemaPlanilla:	string;
  ApellidoPaterno: string;
  ApellidoMaterno: string;
  CodEsquemaPlanilla: string;
  Nombres: string; 
  Sexo: 'M' | 'F';
  CodTipoDocumento: string;
  TelefonoMovil: string;
  ProyectoDestino: string;
}

export interface ApprovalEmployeesPartial {
  EmployeeCode: string;
  Id: number;
}

export interface CorporationByModule {
  SecurityCorporationId: number;
  SecurityCorporationModuleId: number;
  ProviderCorporationId: number;
  RUC: string;
  Name: string;
  SignalRConnectionId: string | null;
}

export interface CorporationUserByModule {
  CorporationModuleId: number;
  RoleId: number;
  RoleName: string;
  UserCorporationModuleId: number;
  PhotoStorageId: null | string;
  UserName: string;
  Password: string;
  HasMasterAccess: boolean;
  SecurityUserCorporationModules: null | any;
  SecurityUserCorporation: any[];
  Code: null | string;
  IsInherited: boolean;
  Id: number;
  Name: string;
  IsActive: boolean;
  AllowAuditTrail: boolean;
} 